import gql from 'graphql-tag';

import { onDemandAssignmentPresentationsFragments } from 'bundles/compound-assessments/components/api/onDemandAssignmentPresentationsQuery';

export default gql`
  query OnDemandAssignmentPresentationsGraderQuery($userId: String!, $courseId: String!, $itemId: String!) {
    OnDemandAssignmentPresentationsV1 @naptime {
      grader(userId: $userId, courseId: $courseId, itemId: $itemId) {
        elements {
          submissionStatus
          latestGraderAction {
            actorName
            actionTime
          }
          phases {
            ... on NaptimeOnDemandAssignmentPresentationsV1_phases_singleFormPhase {
              typeName
              definition {
                baseTaskId
                deadline

                task @type(name: "NaptimeOnDemandAssignmentPresentationsV1_Task") {
                  ...FormTaskFragment
                }
                fulfilled
              }
            }
            ... on NaptimeOnDemandAssignmentPresentationsV1_phases_reviewPhase {
              ...ReviewPhaseFragment
            }
          }
          teamId
          teamNeedsToBeAssigned
          assignmentVersionOutdated

          grade {
            ...GradeFragment
          }

          userId
          courseId
          itemId
        }
      }
    }
  }
  ${onDemandAssignmentPresentationsFragments}
`;
